import * as Sentry from '@sentry/react';
import { createActions } from 'redux-actions';
import { requestNoAuthentication, request, update,
  saveAuthToken } from '../../services';

export const loginUserRequest = () => ({ type: 'LOGIN_USER_REQUEST' });

export function loginUserSuccess(payload) {
  return { type: 'LOGIN_USER_SUCCESS', payload };
}

export function loginUserFailure(errorMessage) {
  return { type: 'LOGIN_USER_FAILURE', payload: { error: errorMessage } };
}

export function logoutUser(reason = null) {
  return { type: 'LOGOUT_USER', payload: { reason } };
}

export const initTokenRefresh = token => (
  { type: 'INIT_TOKEN_REFRESH', payload: { token } }
);

/* TODO
 * Get lastRequestTime and token from redux state instead of local storage
 * Save token in redux state on successful refresh
 * Trigger token refresh when loading token from local storage
 *
 * refreshToken is called when jwt-autorefresh needs to obtain a new token
 * because the previous one is about to expire.
*/
export const refreshToken = () =>
  dispatch =>
    request('/refresh_token', {
      method: 'POST',
    })
    .then(({ json }) => {
      const user = Sentry.getCurrentHub().getScope().getUser();
      Sentry.setUser({
        ...user,
        token: json.auth_token,
      });
      Sentry.addBreadcrumb({
        message: 'Token Updated',
        category: 'auth',
        level: 'info',
        data: {
          token: json.auth_token,
        },
      });
      saveAuthToken(json.auth_token);
      return json.auth_token;
    })
    .catch((error) => {
      dispatch(logoutUser('You have been logged out - token not refreshed successfully.'));
      return Promise.reject(new Error(`Token not refreshed${error.json ? ` - ${error.json.errors}` : ''}`));
    });


export function signInGoogleUser(googleAuthObj) {
  return (dispatch) => {
    dispatch(loginUserRequest());

    requestNoAuthentication('/oauth2callback', {
      method: 'POST',
      body: googleAuthObj,
    })
    .then(({ json }) => {
      dispatch(loginUserSuccess({ ...json.user, msal: null }));
      dispatch(initTokenRefresh(json.user.auth_token));
    })
    .catch(error => dispatch(loginUserFailure(error.json.error)));
  };
}

export function signInMicrosoftUser(microsoftAuthObj, msal = null) {
  return (dispatch) => {
    dispatch(loginUserRequest());

    requestNoAuthentication('/oauth2callback', {
      method: 'POST',
      body: microsoftAuthObj,
    })
    .then(({ json }) => {
      dispatch(loginUserSuccess({ ...json.user, msal }));
      dispatch(initTokenRefresh(json.user.auth_token));
    })
    .catch(error => dispatch(loginUserFailure(error.json.error)));
  };
}

const {
  userGetSessionRequest,
  userGetSessionSuccess,
  userGetSessionFailure,
} = createActions({
  USER_GET_SESSION_SUCCESS: json => json.user,
},
  'USER_GET_SESSION_REQUEST',
  'USER_GET_SESSION_FAILURE',
);

export function userGetSession() {
  return (dispatch) => {
    dispatch(userGetSessionRequest());
    return request('/session')
      .then(({ json }) => {
        dispatch(userGetSessionSuccess(json));
        dispatch(initTokenRefresh(json.user.auth_token));
      })
      .catch(error => dispatch(userGetSessionFailure(error)));
  };
}


const {
  userResendLinkRequest,
  userResendLinkSuccess,
  userResendLinkFailure,
} = createActions(
  'USER_RESEND_LINK_REQUEST',
  'USER_RESEND_LINK_SUCCESS',
  'USER_RESEND_LINK_FAILURE',
  );

export function userResendLink(userId) {
  return (dispatch) => {
    dispatch(userResendLinkRequest());
    return request(`users/${userId}/resend_link`, {
      method: 'POST',
    })
      .then(({ json }) => dispatch(userResendLinkSuccess(json)))
      .catch(error => dispatch(userResendLinkFailure(error)));
  };
}

const {
  userUpdatePreferencesRequest,
  userUpdatePreferencesSuccess,
  userUpdatePreferencesFailure,
} = createActions({
  USER_UPDATE_PREFERENCES_SUCCESS: json => json.user,
},
  'USER_UPDATE_PREFERENCES_REQUEST',
  'USER_UPDATE_PREFERENCES_FAILURE',
);

export function userUpdatePreferences(prefs) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(userUpdatePreferencesRequest(prefs));
    return update('user', {
      id: state.user.id,
      preferences: { ...state.user.preferences, ...prefs },
    })
      .then(({ json }) => dispatch(userUpdatePreferencesSuccess(json)))
      .catch(error => dispatch(userUpdatePreferencesFailure(error)));
  };
}

const {
  userBadgeUpdateRequest,
  userBadgeUpdateSuccess,
} = createActions('USER_BADGE_UPDATE_REQUEST', 'USER_BADGE_UPDATE_SUCCESS', 'USER_BADGE_UPDATE_FAILURE');

export function updateUserBadge(userID, badge) {
  return (dispatch) => {
    dispatch(userBadgeUpdateRequest());

    return request(`users/${userID}/badge`, { method: 'PATCH', body: { badge } })
      .then(({ json }) => dispatch(userBadgeUpdateSuccess(json)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/user.js